import * as React from "react";
import { Tooltip, UncontrolledTooltip } from "reactstrap";
import { ReactElement, useState } from "react";

interface Props {
  element: ReactElement,
  tooltip: any,
  params?: {[key: string]: any},
  uncontrolled?: boolean,
  wrapper?: {
    component: any,
    params?: {[key: string]: any},
  },
}

function TooltipComponent({ element, tooltip, params, uncontrolled, wrapper }: Props) {
    
  const [target, setTarget] = useState<HTMLElement | null>(null);
  const ready = target !== null;

  const { children, ...elementProps } = element.props;
  const myElement = (
    <element.type
        ref={setTarget}
        {...elementProps}
    >
      {children}
    </element.type>
  )
  const MyTooltip = uncontrolled === true ? UncontrolledTooltip : Tooltip;
    
  return (
    <>

      {wrapper !== undefined && wrapper !== null ? (
        <wrapper.component
          {...((wrapper.params !== undefined && wrapper.params !== null) ? wrapper.params : {})}
        >
          {myElement}
        </wrapper.component>
      ) : myElement}

      {ready && (
        <MyTooltip
          target={target}
          boundariesElement="window"
          {...params}
        >
          {tooltip}
        </MyTooltip>
      )}
    </>
  )
    
}

export default TooltipComponent;
